// React imports
import React from "react";
// Material imports
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
// Other imports
import PropTypes from "prop-types";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { colors, outlineButton } from "../../theme/tokens";
const styles = {
  hero: {
    padding: "0 0 24px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start"
  },
  copy: {
    flex: "1 1 380px",
    minWidth: 0,
    paddingRight: "40px",
    paddingTop: "2px"
  },
  copySmall: {
    flex: "1 1 100%",
    minWidth: 0,
    paddingRight: 0,
    paddingTop: "2px"
  },
  welcome: {
    color: colors.brand,
    fontSize: "clamp(38px, 5.4vw, 62px)",
    fontWeight: 700,
    lineHeight: "1.02",
    letterSpacing: "-.065em",
    marginBottom: "9px"
  },
  headline: {
    color: colors.brandDeep,
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "1.2",
    letterSpacing: "-.035em",
    marginBottom: "18px"
  },
  subline: {
    color: "#4f646d",
    fontSize: "17px",
    lineHeight: "1.55",
    maxWidth: "520px",
    marginBottom: "0"
  },
  description: {
    maxWidth: "620px",
    marginTop: "24px",
    color: colors.muted,
    fontSize: "14px",
    lineHeight: "1.65"
  },
  descriptionParagraph: {
    color: colors.muted,
    fontSize: "14px",
    lineHeight: "1.65",
    marginBottom: "13px"
  },
  inlineLink: {
    color: colors.brandDeep,
    fontWeight: 700,
    textDecoration: "underline",
    cursor: "pointer"
  },
  heroLinks: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "22px"
  },
  heroLink: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "220px",
    marginRight: "26px",
    padding: "11px 0 9px",
    color: colors.brandDeep,
    borderBottom: "1px solid " + colors.brand,
    borderRadius: 0,
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: ".02em",
    textTransform: "uppercase"
  },
  side: {
    flex: "0 0 220px",
    borderLeft: "1px solid " + colors.line,
    paddingLeft: "22px",
    paddingTop: "2px"
  },
  sideSmall: {
    flex: "1 1 100%",
    borderTop: "1px solid " + colors.line,
    marginTop: "28px",
    paddingTop: "20px"
  },
  sideLabel: {
    color: colors.brand,
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: ".11em",
    textTransform: "uppercase",
    marginBottom: "14px"
  },
  quickNavButton: {
    ...outlineButton,
    width: "100%",
    marginBottom: "8px"
  }
};
const HeroSection = ({
  translate,
  links,
  infoLinks,
  showGuestInfo,
  onRegisterClick,
  width
}) => {
  const wide = isWidthUp("md", width);
  return (
    <div style={styles.hero}>
      <div style={wide ? styles.copy : styles.copySmall}>
        <Typography variant="display1" style={styles.welcome}>
          {translate("dashboard.hero.welcome")}
        </Typography>
        <Typography variant="subheading" style={styles.headline}>
          {translate("dashboard.hero.headline")}
        </Typography>
        <Typography variant="body1" style={styles.subline}>
          {translate("dashboard.hero.subline")}
        </Typography>
        {showGuestInfo && (
          <div style={styles.description}>
            <Typography variant="body1" style={styles.descriptionParagraph}>
              {translate("dashboard.hero.free")}
            </Typography>
            <Typography variant="body1" style={styles.descriptionParagraph}>
              {translate("dashboard.hero.premiumPrefix")}
              <span style={styles.inlineLink} onClick={onRegisterClick}>
                {translate("dashboard.hero.premiumLink")}
              </span>
              {"."}
              <br />
              {translate("dashboard.hero.loginHint")}
            </Typography>
          </div>
        )}
        {showGuestInfo && (
          <div style={styles.heroLinks}>
            {infoLinks.map(link => (
              <Button
                key={link.label}
                style={styles.heroLink}
                onClick={link.onClick}
              >
                <span>{link.label}</span>
                <span aria-hidden="true">&rarr;</span>
              </Button>
            ))}
          </div>
        )}
      </div>
      <div style={wide ? styles.side : styles.sideSmall}>
        <div style={styles.sideLabel}>
          {translate("dashboard.hero.quickNav")}
        </div>
        {links.map(link => (
          <Button
            key={link.label}
            style={styles.quickNavButton}
            onClick={link.onClick}
          >
            <span>{link.label}</span>
            <span aria-hidden="true">&rarr;</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
HeroSection.propTypes = {
  translate: PropTypes.func.isRequired,
  links: PropTypes.array.isRequired,
  infoLinks: PropTypes.array,
  showGuestInfo: PropTypes.bool,
  onRegisterClick: PropTypes.func,
  width: PropTypes.string
};
HeroSection.defaultProps = {
  infoLinks: [],
  showGuestInfo: false
};
export default withWidth()(HeroSection);
